import PropTypes from 'prop-types'

import {
  PanelHeader,
  PanelTitle,
  PanelSection
} from 'components/attacks/details/AttackStyles'
import Execution from 'components/attacks/details/Execution'

export default function ExecutionPanel({ attackId, executions }) {
  return (
    <PanelSection>
      <PanelHeader>
        <PanelTitle>Executions</PanelTitle>
      </PanelHeader>
      {executions.map(execution => (
        <Execution
          key={execution.guid}
          attackId={attackId}
          execution={execution}
        />
      ))}
    </PanelSection>
  )
}

ExecutionPanel.propTypes = {
  attackId: PropTypes.string,
  executions: PropTypes.array
}
